import Config from '../config';

interface ExtendedWindow extends Partial<Window & typeof globalThis> {
  ym?: any
}

export const sendMetrik = (type: string, value: string) => {
  if (Config.ENV === 'production') (window as ExtendedWindow).ym(85846775, type, value);
};
